// Percent-decoded last path segment of a URL, for showing a file name when
// an attachment has no description.
export const fileNameFromUrl = (url, fallback, { stripExtension } = {}) => {
  const last = (url || '').split('?')[0].split('#')[0].split('/').pop()
  if (!last) return fallback
  let name = last
  try {
    name = decodeURIComponent(last)
  } catch {
    // keep the raw segment when the URL is not valid encoding
  }
  if (stripExtension) {
    name = name.replace(/\.[a-z0-9]{1,5}$/i, '')
  }
  return name || fallback
}

export const fileExtension = (url) => {
  const name = fileNameFromUrl(url, '')
  const match = name.match(/\.([a-z0-9]{1,5})$/i)
  return match ? match[1].toUpperCase() : null
}
